export default "__VITE_ASSET__CvHNj4V8__"